import type { CartItem, CartData, CartUrls } from 'types'

export function createCartItemQueryString(cartItems: CartItem[]): string {
  if (!cartItems?.length) return ''

  const paramPairs: string[] = []

  for (const [index, cartItem] of cartItems.entries()) {
    if (index === 0) {
      paramPairs.push(
        `id=${cartItem.variant_id}`,
        `quantity=${cartItem.quantity}`
      )

      if (cartItem.selling_plan_allocation?.selling_plan?.id) {
        paramPairs.push(
          `selling_plan=${cartItem.selling_plan_allocation.selling_plan.id}`
        )
      }

      if (cartItem.properties && Object.keys(cartItem.properties).length > 0) {
        for (const [key, value] of Object.entries(cartItem.properties)) {
          paramPairs.push(`properties[${key}]=${encodeURIComponent(value)}`)
        }
      }
    } else {
      paramPairs.push(
        `items[${index}][id]=${cartItem.variant_id}`,
        `items[${index}][quantity]=${cartItem.quantity}`
      )

      if (cartItem.selling_plan_allocation?.selling_plan?.id) {
        paramPairs.push(
          `items[${index}][selling_plan]=${cartItem.selling_plan_allocation.selling_plan.id}`
        )
      }

      if (cartItem.properties && Object.keys(cartItem.properties).length > 0) {
        for (const [key, value] of Object.entries(cartItem.properties)) {
          paramPairs.push(
            `items[${index}][properties][${key}]=${encodeURIComponent(value)}`
          )
        }
      }
    }
  }
  return paramPairs.join('&')
}

export function buildCartActionUrl(
  cartItems: CartItem[],
  shopDomain: string,
  returnTo: string
): string {
  const queryString = createCartItemQueryString(cartItems)
  if (!queryString) return ''

  const encodedReturnTo = encodeURIComponent(
    `/cart/add?${queryString}&return_to=${returnTo}`
  )

  return `https://${shopDomain}/cart/clear?return_to=${encodedReturnTo}`
}

export function buildCartUrls(cart: CartData, shopDomain: string): CartUrls {
  if (!cart?.items?.length) {
    return { cartUrl: '', checkoutUrl: '' }
  }

  return {
    cartUrl: buildCartActionUrl(cart.items, shopDomain, '/cart'),
    checkoutUrl: buildCartActionUrl(cart.items, shopDomain, '/checkout'),
  }
}
